import React, { Component } from 'react';
import styles from './style.less';

// 将 【标题】内容 形式的通知文本解析为分区（不使用正则，避免特殊字符误判）
function parseSections(content) {
  const sections = [];
  if (!content || !content.trim()) return sections;
  const parts = content.split('【');
  for (const part of parts) {
    const idx = part.indexOf('】');
    if (idx > -1) {
      const title = part.slice(0, idx).trim();
      const body = part.slice(idx + 1).trim();
      if (body) {
        sections.push({ title, body });
      }
    } else if (part.trim()) {
      sections.push({ title: '', body: part.trim() });
    }
  }
  return sections;
}

export default class Rule extends Component {
  render() {
    const { content, fileList } = this.props.competition || {}; //获取赛制内容和附件列表
    const sections = parseSections(content || '');

    return (
      <div className={styles['rule-container']}>
        {sections.length === 0 ? (
          <div className={styles['empty-tip']}>
            {content === undefined ? '加载中…' : '暂无赛制说明'}
          </div>
        ) : null}
        {sections.map((s, i) => (
          <div className={styles['section']} key={i}>
            {s.title ? (
              <div className={styles['section-title']}>{s.title}</div>
            ) : null}
            <div className={styles['section-body']}>{s.body}</div>
          </div>
        ))}
        {fileList && fileList.length ? (
          <div className={styles['file-list']}>
            {fileList.map((file, i) => (
              <div key={i} className={styles['file-item']}>
                <a href={file.url} download={file.name}>
                  {file.name}
                </a>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    );
  }
}